

const swiperSlides = document.getElementsByClassName('.top-course-topics-wrap swiper-slide');
const breakPoint = 768;
var mySwiper ;
var mySwiperBool ;


window.addEventListener('load',()=>{
    if( breakPoint < window.innerWidth){
        mySwiperBool = false;
    }else{
        createSwiper();
        mySwiperBool = true;
    }
},false);

window.addEventListener('resize',()=>{
    if( breakPoint < window.innerWidth && mySwiperBool){
        mySwiper.destroy(false,true);
        mySwiperBool = false;
    }else if( breakPoint >= window.innerWidth && !(mySwiperBool)){
        createSwiper();
        mySwiperBool = true;
    }
},false);

const createSwiper = () =>{
    mySwiper = new Swiper('.top-course-topics-wrap', {
        loop: true,
        autoHeight: true,
        slidesPerView: 1,
        spaceBetween: 20,
        // ページネーション
        pagination: {
            el: ".top-course-topics-wrap .swiper-pagination",
            type: "fraction", // 枚数表示
            clickable: true,
        },
        // 前後の矢印
        navigation: {
            nextEl: ".top-course-topics-wrap .swiper-button-next",
            prevEl: ".top-course-topics-wrap .swiper-button-prev",
        },
    });
}




//|||||||||||||||||||||||||||||||||||||||||||||||||||||||
//ハンバーガーメニュー
//

document.querySelector('.header-sp-btn-wrap').addEventListener('click', function(){
    this.classList.toggle('active');
    document.querySelector('.header-sp-menu-wrap').classList.toggle('active');
})